export enum DocumentType {
  ADDITIONAL = 'additional',
  REFERENCE = 'reference',
  INSPIRATION = 'inspiration',
  SOURCE = 'source',
}
